<template>
  <v-dialog v-model="modelTroca" width="500px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="item != null">
      <div class="px-8">
        <ImageProduct :image="image"></ImageProduct>
      </div>
      <v-card-text class="px-8 pt-8">
        <h3 class="text-color-0">{{ item.name }}</h3><br>
        <span class="text-color-0">{{ description }}</span>
      </v-card-text>
      <v-card-actions class="px-8 pb-8">
        <v-btn block flat disabled class="br-5 text-color-white bg-color-0 text-medium opacity-85">{{ item.points_value }} pontos</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ImageProduct from '@/components/ImageProduct.vue';
import { mapActions } from 'vuex';
export default {
  name: 'DialogTroca',
  components: {
    ImageProduct
  },
  data(){
    return {
      modelTroca: false,
      image: null,
      imghash: null,
      description: ""
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelTroca = this.model;
    },
    item(){
      if(this.item != null){
        this.loadProductsDetail(this.item.sku).then(function(response){
          this.imghash = response.imghash;
          this.description = response.description;
          this.getImageCarousel({ sku: this.item.sku, imghash: this.imghash }).then(function(image){
            this.image = image;
          }.bind(this));
        }.bind(this));
      } else {
        this.image = null;
      }
    }
  },
  methods: {
    ...mapActions('products', {
      getImageCarousel: 'getImageCarousel',
    }),
    ...mapActions('services', {
      loadProductsDetail: 'loadProductsDetail'
    }),
  }
}
</script>